/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { Svg } from 'app/components/common';
import PropTypes from 'prop-types';
import { logBannerTap } from 'app/events/Events';
import { buttonEventClick } from 'clevertap/LogEvent';
import Event from 'clevertap/Event';
import CustomSwiperCarousel from '../CustomSwiperCarousel';
import QuickCard from '../QuickCard';
import '../../../styles/home/homeNew.scss';

const style = {
  slide_wrapper: {
    paddingBottom: '2.5rem',
    position: 'relative',
    cursor: 'pointer',
  },
  play_button: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -70%)',
    border: 'none',
    background: 'none',
  },
};

const BannerTop = ({
  banners, setBrandVideoLink, toggleVideoModal, isMobile, history,
}) => {
  const imageSlides = [];
  const [showPromotionPopup, setShowPromotionPopup] = React.useState(false);
  banners.map((banner) => (
    (banner.bannerLocation === 'BANNER_TOP' && !banner.videoLink)
    && imageSlides.push(
      <swiper-slide key={banner.bannerId}>
        <div
          style={style.slide_wrapper}
          onClick={() => {
            if (banner.isLeadCollectionBanner) {
              if (!showPromotionPopup) {
                logBannerTap();
                setShowPromotionPopup(true);
              }
            }
            if (banner.isFreeSampleBanner) {
              history.push({
                pathname: '/shops',
                state: {
                  filterCategoryId: 'FREESAMPLE',
                  filterId: 'FREE_SAMPLE',
                  scrollToTop: true,
                },
              });
            }
            buttonEventClick(
              Event.LL_Banner_Clicked,
              {
                Page: 'Home_Tab',
                'Banner name': banner.title,
                Section: 'Top banners',
              },
            );
          }}
        >
          <QuickCard
            name={banner.title}
            link={(banner.isFreeSampleBanner || banner.isLeadCollectionBanner) ? '' : banner.deepLink.web}
            image={isMobile
              ? banner.image : banner.webImage}
            cardStyle={
              {
                width: '1170px',
                height: isMobile ? '180px' : '300px',
                overflow: 'hidden',
                borderRadius: '16px',
              }
            }
            showPromotionPopup={showPromotionPopup}
            onHidePromotionPopup={() => {
              setShowPromotionPopup(false);
            }}
          />
        </div>
      </swiper-slide>,
    )
  ));
  const videoSlides = [];
  banners.map((banner) => (
    (banner.bannerLocation === 'BANNER_TOP' && banner.videoLink)
    && videoSlides.push(
      <swiper-slide key={banner.bannerId}>
        <div style={style.slide_wrapper}>
          <QuickCard
            name={banner.title}
            image={(isMobile) ? banner.image : banner.webImage}
            cardStyle={
            {
              width: '1170px',
              height: isMobile ? '180px' : '300px',
              overflow: 'hidden',
              borderRadius: '16px',
            }
          }
          />
        </div>
        <button
          type="button"
          aria-label="Play video"
          style={style.play_button}
          onClick={() => { setBrandVideoLink(banner); toggleVideoModal(); }}
        >
          <Svg
            svg="playNew"
            width="60px"
            fill="#fff"
          />
        </button>
      </swiper-slide>,
    )
  ));

  const slides = [...videoSlides, ...imageSlides];

  let onlyOneSlide = false;

  if (slides.length === 1) {
    onlyOneSlide = true;
  }

  return (
    <div className="r__banner_wrapper">
      <CustomSwiperCarousel
        slides={slides}
        slidesPerView={(onlyOneSlide) ? 1 : 1.05}
        spaceBetween={8}
        autoPlay
        speed={500}
        pagination
        paginationClickable
      />
    </div>
  );
};

BannerTop.propTypes = {
  banners: PropTypes.arrayOf(PropTypes.shape({})),
  setBrandVideoLink: PropTypes.func,
  toggleVideoModal: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func,
    replace: PropTypes.func,
  }).isRequired,
  isMobile: PropTypes.bool.isRequired,
};

BannerTop.defaultProps = {
  banners: [],
  setBrandVideoLink: () => {},
  toggleVideoModal: () => {},
};

export default BannerTop;
